import {MoneyInput} from '@frontend/components/inputs/MoneyInput'
import {trans} from '@frontend/helpers'
import {useRegionConfig} from '@frontend/hooks'
import {FilterLabel} from './FilterLabel'

interface Props {
    minPrice: number | null
    maxPrice: number | null
    setMinPrice: (value: number | null) => void
    setMaxPrice: (value: number | null) => void
    disabled?: boolean
}

// Фильтр по цене.
export function PriceFilter(props: Props) {

    const regionConfig = useRegionConfig()

    const {
        minPrice,
        maxPrice,
        setMinPrice,
        setMaxPrice,
        disabled,
    } = props

    return (
        <>
            <FilterLabel
                label={trans().ads.list.filters.price}
                className="mb-2"
                showResetButton={minPrice !== null || maxPrice !== null}
                disabled={disabled}
                onReset={() => {
                    setMinPrice(null)
                    setMaxPrice(null)
                }}
            />
            <MoneyInput
                label={trans().ads.list.filters.price_from}
                value={String(minPrice ?? '')}
                maxLength={regionConfig.adPrice.maxDigits}
                numeralFormat={regionConfig.moneyInput.numeralFormatForPriceFilter}
                small
                wrapperClassName="mb-3"
                disabled={disabled}
                onChange={(_e, _formattedValue, cleanValue) => {
                    setMinPrice(cleanValue)
                }}
            />
            <MoneyInput
                label={trans().ads.list.filters.price_to}
                value={String(maxPrice ?? '')}
                maxLength={regionConfig.adPrice.maxDigits}
                numeralFormat={regionConfig.moneyInput.numeralFormatForPriceFilter}
                small
                disabled={disabled}
                onChange={(_e, _formattedValue, cleanValue) => {
                    setMaxPrice(cleanValue)
                }}
            />
        </>
    )
}
